import { useMemo } from 'react';

type FilterType = 'Price' | 'Size' | 'Other';

export const useFilterType = (selectedFilter?: string | null) => {
    const type: FilterType = useMemo(() => {
        const filterKey = selectedFilter?.toLocaleLowerCase();
        if (filterKey?.includes('price')) {
            return 'Price';
        }

        if (filterKey?.includes('size')) {
            return 'Size';
        }

        return 'Other';
    }, [selectedFilter]);

    return type;
};
